<template>
  <div class="kpi-tooltip-icon">
    <LeftAlignTooltip>
      <Icon
        :size="size"
        :color="tooltipColor"
      >
        mdi-information
      </Icon>
      <template v-slot:content>
        {{ tooltip }}
      </template>
    </LeftAlignTooltip>
  </div>
</template>

<script>
import { Icon, LeftAlignTooltip } from '@mikmak/components';

export default {
  components: {
    Icon,
    LeftAlignTooltip,
  },
  data() {
    return {
      tooltipColor: '#223448',
    };
  },
  props: {
    tooltip: String,
    size: {
      type: String,
      default: 'small',
    },
  },
};
</script>

<style scoped>
.kpi-tooltip-icon {
  position: absolute;
  top: 8px;
  left: 8px;
  font-size: 10px;
}

</style>
